import { useEffect, useState } from "react";

export function useVariant() {
  const getVariant = () => (window.innerWidth < 768 ? "mobile" : "desktop");

  const [variant, setVariant] = useState(getVariant);

  useEffect(() => {
    const handleResize = () => {
      setVariant(getVariant());
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return variant;
}
